import { hasPermission } from "../../Config/permissions.js";

export const isOwnAccountForChangeRequest = (user, routeAccountId) =>
  user?.Type === "Account" &&
  Number.isInteger(Number(user?.AccountID)) &&
  Number(user.AccountID) > 0 &&
  Number(user.AccountID) === Number(routeAccountId);

export const canRequestAccountChanges = ({ user, routeAccountId, readOnly }) =>
  !readOnly &&
  isOwnAccountForChangeRequest(user, routeAccountId) &&
  hasPermission(user, "account_update.request");

export const getAccountChangeRequestBanner = (request) => {
  if (request?.Status === "Pending") {
    return {
      type: "info",
      message: "Account changes are pending review",
      description:
        "Your current account information will remain unchanged until an administrator approves the request.",
    };
  }
  if (request?.Status === "Rejected") {
    return {
      type: "warning",
      message: "Your latest account change request was rejected",
      description: request.RejectionReason || "No reason was provided.",
    };
  }
  return null;
};
